/* Progressive enhancement: a failed/slow alternate image never hides the main.
   Delegated listeners also cover AJAX filters and predictive search results. */
(() => {
  const selector = '.ed-card-2027 .product-card__image-wrapper';
  const pending = new WeakMap();
  async function prepare(frame) {
    const image = frame.querySelector('.ed-card__media--second img');
    if (!image || frame.hasAttribute('data-secondary-ready') || pending.has(image)) return;
    pending.set(image, true);
    try {
      image.loading = 'eager';
      await image.decode();
      if (image.naturalWidth > 0 && frame.isConnected) frame.setAttribute('data-secondary-ready', '');
    } catch (_) {
      frame.removeAttribute('data-secondary-ready');
    } finally {
      pending.delete(image);
    }
  }
  document.addEventListener('pointerover', (event) => {
    if (event.pointerType !== 'mouse') return;
    const frame = event.target.closest(selector);
    if (frame) prepare(frame);
  });
  document.addEventListener('load', (event) => {
    if (!(event.target instanceof HTMLImageElement)) return;
    if (!event.target.matches('.ed-card__media--second img')) return;
    const frame = event.target.closest(selector);
    if (frame) prepare(frame);
  }, true);
})();
